import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from "axios";
import '../../App.css';
import '../styles/NltxEmployees.css'
import ChartBarNominal from '../js/ChartBarNominal';
import ChartGauge from '../js/ChartGauge';
import ChartLine from '../js/ChartLine';

export default function NltxEmployees() {
    useEffect(() => {
        document.title = "Analytics | Employees"; // Set the tab name
    }, []);

    const [dataCounts, setDataCounts] = useState({
        employeeTaskUnassigned: 0,
        employeeRequestsOpen: 0,
        employeeRequestDone: 0,
        employeeTaskForwarded: 0
    });

    const [searchValue, setSearchValue] = useState('');
    const [searchUserWf, setSearchUserWf] = useState('');
    const [workflowRows, setWorkflowRows] = useState([]);
    const [workflowRowsOriginal, setWorkflowRowsOriginal] = useState([]);

    const [selectedGroup, setSelectedGroup] = useState(null);
    const [filteredSelectedRows, setFilteredSelectedRows] = useState([]);

    const handleSearchChange = (e) => {
        const searchQuery = e.target.value.toLowerCase();
        setSearchValue(searchQuery);

        if (!searchQuery) {
            // If input is cleared, reset to original data
            setWorkflowRows(workflowRowsOriginal);
            setPageNow(1);
            return;
        }

        const grouped = workflowRowsOriginal.reduce((acc, row) => {
            if (!acc[row.ref]) acc[row.ref] = [];
            acc[row.ref].push(row);
            return acc;
        }, {});

        const filteredGroups = Object.values(grouped).filter(group =>
            group.some((row) =>
                (row.ref?.toLowerCase() || '').includes(searchQuery) ||
                (row.name_action?.toLowerCase() || '').includes(searchQuery) ||
                (row.status_action?.toLowerCase() || '').includes(searchQuery) ||
                (row.feedback?.toLowerCase() || '').includes(searchQuery) ||
                (String(row.stage_now) || '').includes(searchQuery) ||
                (String(row.stage_max) || '').includes(searchQuery) ||
                (String(row.score_eff) || '').includes(searchQuery) ||
                (String(row.score_prod) || '').includes(searchQuery) ||
                (String(row.created_by) || '').includes(searchQuery) ||
                (String(row.updated_by) || '').includes(searchQuery) ||
                (row.due_date?.toLowerCase() || '').includes(searchQuery) ||
                (row.updated_date?.toLowerCase() || '').includes(searchQuery) ||
                (row.created_date?.toLowerCase() || '').includes(searchQuery) ||
                (row.user_firstname?.toLowerCase() || '').includes(searchQuery) ||
                (row.user_middlename?.toLowerCase() || '').includes(searchQuery) ||
                (row.user_lastname?.toLowerCase() || '').includes(searchQuery) ||
                (row.updated_user_firstname?.toLowerCase() || '').includes(searchQuery) ||
                (row.updated_user_middlename?.toLowerCase() || '').includes(searchQuery) ||
                (row.updated_user_lastname?.toLowerCase() || '').includes(searchQuery) ||
                (
                    Array.isArray(row.course_names)
                        ? row.course_names.join(', ').toLowerCase().includes(searchQuery)
                        : typeof row.course_names === 'string'
                        ? row.course_names.toLowerCase().includes(searchQuery)
                        : false
                )
            )
        );

        const flattenedRows = filteredGroups.flat();
        setWorkflowRows(flattenedRows);
        setPageNow(1);
    }

    const handleSearchUserWf = (e) => {
        const searchQuery = e.target.value.toLowerCase();
        setSearchUserWf(searchQuery);

        if (!selectedGroup) return;

        if (searchQuery.trim() === '') {
            setFilteredSelectedRows(selectedGroup.rows);
            return;
        }

        const filtered = selectedGroup.rows.filter((row) =>
            (row.created_date?.toLowerCase() || '').includes(searchQuery) ||
            (row.updated_date?.toLowerCase() || '').includes(searchQuery) ||
            (row.due_date?.toLowerCase() || '').includes(searchQuery) ||
            (String(row.stage_now) || '').includes(searchQuery) ||
            (String(row.stage_max) || '').includes(searchQuery) ||
            (row.name_action?.toLowerCase() || '').includes(searchQuery) ||
            (row.status_action?.toLowerCase() || '').includes(searchQuery) ||
            (row.feedback?.toLowerCase() || '').includes(searchQuery)
        );

        setFilteredSelectedRows(filtered);
        setGroupPageNow(1);
    }

    /* small table */
    const [groupPageNow, setGroupPageNow] = useState(1);
    const groupRowsPerPage = 3;
    const groupIndxLast = groupPageNow * groupRowsPerPage;
    const groupIndxFirst = groupIndxLast - groupRowsPerPage;
    const paginatedGroupRows = filteredSelectedRows.slice(groupIndxFirst, groupIndxLast);
    
    const groupTotalPages = Math.ceil(filteredSelectedRows.length / groupRowsPerPage);
    
    

    /* main table */
    const [pageNow, setPageNow] = useState(1);
    const rowsNow = 15; // TODO user can adjust how many rows to see
    var indxLast = pageNow * rowsNow;
    var indxFirst = indxLast - rowsNow;

    // const groupedRowsMap = workflowRows.reduce((acc, row) => {
    //     if (!acc[row.ref]) acc[row.ref] = [];
    //     acc[row.ref].push(row);
    //     return acc;
    // }, {});

    const groupedRowsMap = workflowRows.reduce((acc, row) => {
        let groupKey;
    
        if (row.ref && row.ref.trim() !== '') {
            // Group by ref if it exists
            groupKey = row.ref;
        } else {
            // If no ref, group by created_by + date (YYYY-MM-DD)
            const createdDate = row.created_date ? new Date(row.created_date) : null;
            if (createdDate) {
                const year = createdDate.getFullYear();
                const month = (createdDate.getMonth() + 1).toString().padStart(2, '0'); // pad month
                const day = createdDate.getDate().toString().padStart(2, '0'); // pad day
                groupKey = `createdBy:${row.created_by}_date:${year}-${month}-${day}`;
            } else {
                // fallback if no created_date (unlikely but safe)
                groupKey = `createdBy:${row.created_by}_noDate`;
            }
        }
    
        if (!acc[groupKey]) acc[groupKey] = [];
        acc[groupKey].push(row);
        return acc;
    }, {});


    const groupedRowsArray = Object.entries(groupedRowsMap).map(([ref, rows]) => ({
    ref,
    rows,
    }));

    const paginatedGroups = groupedRowsArray.slice(indxFirst, indxLast);
    var pageTotal = Math.ceil(groupedRowsArray.length / rowsNow);
    var pageNumbers = [...Array(pageTotal + 1).keys()].slice(1);

    const pagePrev = () => {
        if (pageNow > 1) {
            setPageNow(pageNow - 1)
        }
    }

    const pageNext = () => {
        if (pageNow < pageTotal) {
            setPageNow(pageNow + 1)
        }
    }

    const changePage = (id) => {
        setPageNow(id)
    }
    
    const [updateTrigger, setUpdateTrigger] = useState(false);
    
    const abbreviateNumber = (number) => {
        if (number >= 1_000_000) {
            return (number / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'; // Abbreviate to 'M' for millions
        } else if (number >= 1_000) {
            return (number / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'; // Abbreviate to 'K' for thousands
        }
        return number.toString(); // Return the number as a string if under 1,000
    };

    const changeViewUser = (group) => {
        // console.warn(group.ref);
        // console.table(group.rows);
        setSelectedGroup(group);
        setFilteredSelectedRows(group.rows);
        setGroupPageNow(1);
    }

    const prodData = selectedGroup
    ? selectedGroup.rows
        .filter(row => row.score_prod !== null && row.created_date)
        .map(row => ({
          date: new Date(row.created_date),
          value: Number(row.score_prod)
        }))
        .sort((a, b) => a.date - b.date)
    : [];

    const effData = selectedGroup
    ? selectedGroup.rows
        .filter(row => row.score_eff !== null && row.created_date)
        .map(row => ({
          date: new Date(row.created_date),
          value: Number(row.score_eff)
        }))
        .sort((a, b) => a.date - b.date)
    : [];

    useEffect(() => {
        const fetchWorkflow = async () => {
          try {
            const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/analyticsUsers.php');
            // console.table(response.data.data);
            
            //console.warn("first data")
            //console.table(response.data.data[0]);

            const displayRows = response.data.data
            .map(row => ({
                id: row.id,
                ref: row.ref,
                name_action: row.name_action,
                status_action: row.status_action,
                feedback: row.feedback,
                stage_now: row.stage_now,
                stage_max: row.stage_max,
                score_eff: row.score_eff,
                score_prod: row.score_prod,
                created_by: row.created_by,
                updated_by: row.updated_by,
                due_date: row.due_date,
                updated_date: row.updated_date,
                created_date: row.created_date,
                user_firstname: row.user_firstname,
                user_middlename: row.user_middlename,
                user_lastname: row.user_lastname,
                updated_user_firstname: row.updated_user_firstname,
                updated_user_middlename: row.updated_user_middlename,
                updated_user_lastname: row.updated_user_lastname,
                course_names: row.user_course_names,


            }));

            // console.warn("got rows:", displayRows);
            // console.warn("response.data.unassigned_users", response.data.data[0].unassigned_users);
            // console.warn("response.data.completed_workflows", response.data.data[0].completed_workflows);

            setWorkflowRows(displayRows);
            setWorkflowRowsOriginal(displayRows);

            setDataCounts({
              employeeTaskUnassigned: abbreviateNumber(response.data.data[0].unassigned_users),
              employeeRequestDone: abbreviateNumber(response.data.data[0].completed_workflows),
            });
          } catch (error) {
            //console.error("Error fetching data counts:", error);
          }
        };
    
        fetchWorkflow();
    }, [updateTrigger]); // Only calls when updateTrigger changes

    useEffect(() => {
        //console.table("new workflowRows:", workflowRows);
    }, [workflowRows])

    const refreshTopData = () => {
        setUpdateTrigger(!updateTrigger);
    };  

    const navigate = useNavigate();
    
    // example graph data
    const example2 = [
        {date: new Date("2024-06-01"), value: 100},
        {date: new Date("2024-07-01"), value: 67},
        {date: new Date("2024-08-01"), value: 92}
    ]

    const example3 = [
        {date: new Date("2024-06-01"), value: 80},
        {date: new Date("2024-07-01"), value: 100},
        {date: new Date("2024-08-01"), value: 75}
    ]

    return (
        <div>
        <div className="analytics-heading">
            <strong className='text'>Employee Analytics</strong>
        </div>

        <section className='dash_overview'>
            <article className='stat_box standalone'>
                <h6 className='title analytics-card'>Unassigned</h6>
                <p className='title body analytics-card'>{dataCounts.employeeTaskUnassigned}</p>
            </article>


            <article className='stat_box standalone'>
                <h6 className='title analytics-card'>Completed&nbsp;Tasks</h6>
                <p className='title body analytics-card'>{dataCounts.employeeRequestDone}</p>
            </article>
        </section>

        <section className='dash_overview' style={{ marginTop: '20px' }}>
            <article className='stats large'>
                {selectedGroup ? (
                <>
                    <h5 className='title'>
                    {selectedGroup.rows[0].ref}
                    </h5>
                    <p>{`${selectedGroup.rows[0].user_lastname}, ${selectedGroup.rows[0].user_firstname} ${selectedGroup.rows[0].user_middlename}`}</p>
                </>
                ) : (
                <p>Select a transaction from the table first.</p>
                )}

                {selectedGroup && (
                    <article className='stat_box'>
                    
                    <header className="header">
                        <input
                            type="text"
                            placeholder="Search workflow history"
                            value={searchUserWf}
                            onChange={handleSearchUserWf}
                            className="search-input"
                        />
                    </header>

                    <table>
                        <thead>
                        <tr>
                            <th>Date Created</th>
                            <th>Date Updated</th>
                            <th>Release Date</th>
                            {/* <th>User</th> */}
                            <th>Action</th>
                            <th>Status</th>
                            <th>Feedback</th>
                            <th>Stage Now</th>
                            <th>Stage Max</th>
                        </tr>
                        </thead>
                        <tbody>
                        {paginatedGroupRows.length > 0 ? (
                        paginatedGroupRows.map((row, idx) => (
                            <tr key={idx}>
                            
                            <td>{row.created_date}</td>
                            <td>{row.updated_date ? row.updated_date : "-"}</td>
                            <td>{row.due_date ? row.due_date : "-"}</td>
                            {/* <td>{`${selectedGroup.rows[0].user_lastname}, ${selectedGroup.rows[0].user_firstname} ${selectedGroup.rows[0].user_middlename}`}</td> */}
                            <td>{row.name_action}</td>
                            <td>{row.status_action}</td>
                            <td>{row.feedback ? row.feedback : "-"}</td>
                            <td>{row.stage_now}</td>
                            <td>{row.stage_max}</td>
                            
                            </tr>
                        ))
                        ) : (
                        <tr>
                            <td colSpan="8" className="no-results">{`No results in workflow for \"${searchUserWf}\"`}</td>
                        </tr>
                        )}
                        </tbody>
                    </table>

                    <div className="pagination">
                        <button onClick={() => setGroupPageNow(1)} disabled={groupPageNow === 1}>&lt;&lt;</button>
                        <button onClick={() => setGroupPageNow(prev => Math.max(prev - 1, 1))} disabled={groupPageNow === 1}>Prev</button>

                        {[...Array(groupTotalPages).keys()].map(i => (
                            <button
                            key={i}
                            className={groupPageNow === i + 1 ? 'active' : ''}
                            onClick={() => setGroupPageNow(i + 1)}
                            >
                            {i + 1}
                            </button>
                        ))}

                        <button onClick={() => setGroupPageNow(prev => Math.min(prev + 1, groupTotalPages))} disabled={groupPageNow === groupTotalPages}>Next</button>
                        <button onClick={() => setGroupPageNow(groupTotalPages)} disabled={groupPageNow === groupTotalPages}>&gt;&gt;</button>
                    </div>

                    </article>
                )}
            </article>
            
            <article className='stats large'>
                {selectedGroup
                ? (
                <h5 className='title'>Productivity & Efficiency</h5>)
                : <p>Select a transaction from the table first.</p>}

                {selectedGroup && (
                    <article className='stat_box'>
                        <ChartLine dataProps1={prodData} dataProps2={effData} nameProps1='Productivity' nameProps2='Efficiency' />
                    </article>
                )}
            </article>
        </section>
        
        <header className="header">
            <input
                type="text"
                placeholder="Search transaction"
                value={searchValue}
                onChange={handleSearchChange}
                className="search-input"
            />
        </header>

        <section className='dash_overview' style={{ marginTop: '20px' }}>
            <table className="documents-table">
                <thead>
                  {paginatedGroups.length > 0 && (
                    <tr>
                      <th>Transaction no.</th>
                      <th>Action</th>
                      <th>Status</th>
                      {/* <th>Created by</th> */}
                      <th>Updated by</th>
                      <th>User</th>
                      <th>Assigned Courses</th>
                      <th>Date Created</th>
                      <th>Date Updated</th>
                    </tr>
                  )
                  }
                </thead>
                <tbody>
                {paginatedGroups.length > 0 ? (
                    paginatedGroups.map((group, index) => {
                        const firstRow = group.rows[0];
                        return (
                            <tr key={index} onClick={() => changeViewUser(group)}>
                            <td>{firstRow.ref ? firstRow.ref : '-'}</td>
                            <td>{firstRow.name_action}</td>
                            <td>{firstRow.status_action}</td>
                            {/* <td>{`${firstRow.user_lastname}, ${firstRow.user_firstname} ${firstRow.user_middlename}`}</td> */}
                            <td>
                            {firstRow.updated_user_lastname && firstRow.updated_user_firstname && firstRow.updated_user_middlename
                                ? `${firstRow.updated_user_lastname}, ${firstRow.updated_user_firstname} ${firstRow.updated_user_middlename}`
                                : '-'}
                            </td>
                            <td>{`${firstRow.user_lastname}, ${firstRow.user_firstname} ${firstRow.user_middlename}`}</td>
                            <td>
                            {Array.isArray(firstRow.course_names)
                                ? firstRow.course_names.join(', ')
                                : typeof firstRow.course_names === 'string'
                                ? firstRow.course_names.split(',').join(', ')
                                : ''}
                            </td>
                            <td>{firstRow.created_date}</td>
                            <td>{firstRow.updated_date}</td>
                        </tr>
                        );
                    })
                ) : (
                    <tr>
                    <td colSpan="13" className="no-results">
                        No results for "{searchValue}"
                    </td>
                    </tr>
                )}
                </tbody>
            </table>
        </section>
        
        {paginatedGroups.length > 0 && (
                <div className="pagination">
                    <button onClick={() => changePage(1)} disabled={pageNow === 1}>&lt;&lt;</button> 
                    <button onClick={pagePrev} disabled={pageNow === 1}>&lt; Previous</button>
    
                    {
                    pageNumbers.map((number, index) => (
                      <button key={index} onClick={() => changePage(number)} className={pageNow === number ? 'active' : ''}>
                        {number}
                      </button>  
                    ))
                    }
                    
                    <button onClick={pageNext} disabled={pageNow === pageTotal}>Next &gt;</button>
                    <button onClick={() => changePage(pageTotal)} disabled={pageNow === pageTotal}>&gt;&gt;</button>
                </div>                    
                )     
            }
    </div>
    );
}
